import type { WrittenPage } from '../../sections'

/**
 * The Guts Check page in Turkish, written 2026-08-31 — the frame around the
 * tool. It waited for the tool itself: a Turkish page around an English
 * twelve-question quiz reads worse than an English page does, and the tool's own
 * copy is now in `content/tools/guts-check.tr.ts`.
 *
 * The eyebrow is spelled in capitals rather than left to `text-transform`, for
 * the same reason `toolsAri` does it: CSS casing follows the document language,
 * and under `lang="tr"` an English name with an `i` in it comes out with `İ`.
 *
 * The product name stays English — a Turkish executive says "Guts Check".
 */
export const toolsGutsCheck: WrittenPage = {
  navLabel: 'The Guts Check',
  title: 'The Guts Check: agentic AI yolculuğunuzda neredesiniz?',
  description:
    'Hedef, sahiplik, icra ve kanıt üzerine on iki soru. Kurumunuzun dört seviyeden gerçekte hangisinde olduğunu ve hedefinizin icra gücünüzden ne kadar uzakta durduğunu görün.',
  sections: [
    {
      kind: 'hero',
      eyebrow: 'THE GUTS CHECK',
      headline: 'Agentic AI yolculuğunuzda neredesiniz?',
      sub: 'Çoğu kurum hedefte, o hedefi gerçek kılacak makineden daha ileridedir. Bu araç ikisini birden ölçüyor ve aradaki mesafeyi söylüyor. Bir dönüşümün teslim mi edileceğini yoksa sessizce daraltılacağını mı önceden haber veren sayı, işte o mesafe.',
      ctas: [],
    },
    { kind: 'tool', tool: 'agentic-guts-check' },
    {
      kind: 'prose',
      heading: 'Bu ne, ne değil',
      paragraphs: [
        'Dört boyut var: hedef, karar ve sahiplik, icra, kanıt. Her biri planlanana göre değil, bugün doğru olduğunu söylediğinize göre puanlanıyor. Seviyeler de sahada gördüklerimiz: kayıtsızlık, verimlilik, olgunluk, yeniden inşa. En üstte neredeyse kimse yok ve gayet iyi yönetilen pek çok şirket, gayet makul sebeplerle en altta.',
        'Bu bir sektör benchmark’ı değil ve size hangi tedarikçiyi alacağınızı söylemiyor. En işe yarar çıktısı da genelde seviye değil, fark: 1. seviye icranın üzerine oturmuş 3. seviye bir hedef, duyurulup sonra küçülen programların en güvenilir habercisidir.',
      ],
    },
  ],
}
